import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VideoBoardAuthService {
  private httpClient = inject(HttpClient);

  connectVenue(deviceId: string, name: string, _venueId: string) {
    return this.httpClient.post<any>('api_endpoint' + '/video-board/connect-venue', { deviceId, name, _venueId }).pipe(
      map(res => res.data)
    );
  }

  getVideoBoardsByMatch(matchId: string) {
    return this.httpClient.get<any>(`api_endpoint/video-board/by-match/${matchId}`).pipe(
      map(res => res)
    );
  }

  updateMatchWithVideoBoard(videoBoardId: string, matchId: string|null) {
    return this.httpClient.post<any>(`api_endpoint/video-board/${videoBoardId}/update-match/${matchId}`, {}).pipe(
      map(res => res)
    );
  }

  connectVenueWithLocation(payload: {deviceId: string, name: string, _venueId: string, court: string, default_view}) {
    return this.httpClient.post<any>('api_endpoint' + '/v2/video-board/connect-venue', payload).pipe(
      map(res => res?.data)
    );
  }


}
